import "./PokerPL.scss";
import React, { useEffect, useState } from 'react'

const PokerPL = ({roundMarkets}) => {
 let [winnerData, setWinnerData] = useState(null);

 const getWinner = () => {
   let winObj = {};
   if (roundMarkets.length > 0) {
     roundMarkets.forEach((market) => {
       market.marketRunner.forEach((runner) => {
         if (runner.status === 'WINNER') {
           winObj[market.marketHeader] = runner.name;
         }
       });
     });
   }
   setWinnerData(winObj)
  }
  useEffect(() => {
    getWinner()
  }, [roundMarkets]);

  const cardSrc = (card) => {
    if (card) {
      return `https://stream.fawk.app/assets/smallCards/${card}.png`;
    } else {
      return "https://stream.fawk.app/assets/smallCards/BACK.png";
    }
  };

    return (
      <div className="poker-betting">
        <div className="poker-betting__games">
          <div className="poker-betting__games-item">
            <span
              className={`poker-betting__games-item-title ${roundMarkets[0].marketRunner[0].status === 'WINNER' ? 'winnerCup':''}`}>
                 Player A
            </span>
            <div className="poker-betting__games-item-cards">
              {roundMarkets && roundMarkets[0].marketRunner[0].cards.map(card => <img className="poker-betting__games-item-cards-card" src={cardSrc(card)} alt={card} key={card}/> )}
            </div>
          </div>
          <div className="poker-betting__games-item">
            <span
              className={`poker-betting__games-item-title ${roundMarkets[0].marketRunner[1].status === 'WINNER' ? 'winnerCup':''}`} >
                Player B
            </span>
            <div className="poker-betting__games-item-cards">
              {roundMarkets && roundMarkets[0].marketRunner[1].cards.map(card => <img className="poker-betting__games-item-cards-card" src={cardSrc(card)} alt={card} key={card}/> )}
            </div>
          </div>
          <div className="poker-betting__games-item">
            <span className="poker-betting__games-item-title">
              Board
            </span>
            <div className="poker-betting__games-item-cards">
              {roundMarkets && roundMarkets[0].indexCard.map(card => <img className="poker-betting__games-item-cards-card" src={cardSrc(card)} alt={card} key={card}/> )}
            </div>
          </div>
        </div>
        <div className="poker-betting__info-column">
          <div className="poker-betting__info-row">
            <div className="poker-betting__info-row-title">
              <span>Winner:</span>
            </div>
            <div className="poker-betting__info-row-results">
              <span>{winnerData && winnerData['Match odds']  || 'No Winner' }</span>
            </div>
          </div>
        </div>
      </div>
    );
};

export default PokerPL;

